import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useFetchUserProfileQuery } from "store/services/user.service";
import Loader from "components/shared/Loader";

const ProtectedRoute = ({ route }) => {
  const isAuthenticated = useSelector((state) => state?.auth?.isAuthenticated);
  const { data: userProfile, isLoading } = useFetchUserProfileQuery(null, { skip: !isAuthenticated });
  const isSubscribed = userProfile?.isSubscribed;
  const location = useLocation();

  if(isLoading) {
    return (
      <div className="fixed-loader">
        <Loader />
      </div>
    )
  }

  // Check for authentication
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Redirect subscribed users if the route prevents them
  if (route.redirectIfSubscribed && isSubscribed) {
    return <Navigate to="/home" />;
  }

  // Block access to exclusive routes for non-subscribed users
  if (route.isExclusive && !isSubscribed) {
    return <Navigate to="/subscription" />;
  }

  // Render the route's component
  return route.component;
};

export default ProtectedRoute;
